import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { CallDto } from 'src/app/shared/models/dto/callDto';

type Stage = 'arrival' | 'berth' | 'sail';

interface StageConfig {
  key: Stage;
  label: string;
  etKey: keyof CallDto;
  atKey: keyof CallDto;
  badge: string;
  etLabel: string;
  atLabel: string;
}

@Component({
  selector: 'app-call-timeline',
  templateUrl: './call-timeline.component.html',
  standalone: false,
})
export class CallTimelineComponent implements OnChanges {
  @Input() call!: CallDto;
  @Output() callUpdated = new EventEmitter<CallDto>();

  stages: StageConfig[] = [
    { key: 'arrival', label: 'Arrival', etKey: 'eta', atKey: 'ata', badge: 'ARRIVED',  etLabel: 'ETA', atLabel: 'ATA' },
    { key: 'berth',   label: 'Berth',   etKey: 'etb', atKey: 'atb', badge: 'BERTHED',  etLabel: 'ETB', atLabel: 'ATB' },
    { key: 'sail',    label: 'Sail',    etKey: 'ets', atKey: 'ats', badge: 'SAILED',   etLabel: 'ETS', atLabel: 'ATS' },
  ];

  currentStage: Stage | null = null;

  ngOnChanges(): void {
    this.resolveCurrentStage();
  }

  private resolveCurrentStage(): void {
    if (!this.call) return;
    if (this.call.ats) { this.currentStage = 'sail';    return; }
    if (this.call.atb) { this.currentStage = 'berth';   return; }
    if (this.call.ata) { this.currentStage = 'arrival'; return; }
    this.currentStage = null;
  }

  isCompleted(stage: StageConfig): boolean {
    return !!this.call?.[stage.atKey];
  }

  isCurrentStage(stage: StageConfig): boolean {
    return this.currentStage === stage.key;
  }

  getDisplayDate(stage: StageConfig): Date | null {
    const atVal = this.call?.[stage.atKey];
    if (atVal) return new Date(atVal as string | Date);
    const etVal = this.call?.[stage.etKey];
    return etVal ? new Date(etVal as string | Date) : null;
  }

  getDisplayLabel(stage: StageConfig): string {
    return this.isCompleted(stage) ? stage.atLabel : stage.etLabel;
  }

}
